import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'

import { SRPRS } from 'components/_Assets/svg/Icon/srprs'
import { ActionListItem } from 'components/ActionList'
import { Button, TYPE } from 'components/Button'

import {
  destinationEnum,
  getDestination,
} from '../../../../data/models/funnelOrder/destination'
import { AppState } from '../../../../data/state'
import TextTooltip from '../../../../elements/tooltips/textTooltip'

interface LockedDestinationProps {
  dest: destinationEnum
}

const LockedDestination: React.FC<LockedDestinationProps> = ({ dest }) => {
  return (
    <ActionListItem
      locked
      icon={SRPRS.mapMarkerColored}
      iconProps={{
        width: '37',
        height: '37',
        viewBox: '0 0 37 41',
        fill: 'none',
      }}
      subject={
        <DisplayContent addNode contentKey="destination">
          Destination
        </DisplayContent>
      }
      value={getDestination(dest)}
      overrideEdit={
        <TextTooltip
          contentKey="destination-tooltip"
          placeholder="Destination Tooltip"
        >
          <Button type={TYPE.lock} negative={true} />
        </TextTooltip>
      }
    />
  )
}

export default connect((state: AppState) => ({
  dest: state.funnelOrder.destination,
}))(LockedDestination)
